import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAuthPopupFormErrors = (errors) => ({
  type: actionTypes.SET_AUTH_POPUP_FORM_ERRORS,
  payload: errors
})
